/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureEpisode from './procedure-episode';
import ProcedureEpisodeDetail from './procedure-episode-detail';
import ProcedureEpisodeUpdate from './procedure-episode-update';
import ProcedureEpisodeDeleteDialog from './procedure-episode-delete-dialog';

const ProcedureEpisodeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureEpisode />} />
    <Route path="new" element={<ProcedureEpisodeUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureEpisodeDetail />} />
      <Route path="edit" element={<ProcedureEpisodeUpdate />} />
      <Route path="delete" element={<ProcedureEpisodeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureEpisodeRoutes;
